import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "./Swipper.css";
import { Navigation } from "swiper/modules";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";


const Category1 = ({ data }) => {
  // Dummy data for categories with placeholder images

  const [backgroundColor, setBackgroundColor] = useState("");
  const [titleColor, setTitleColor] = useState("");
  const [titleFont, setTitleFont] = useState("");
  const [title, setTitle] = useState("");
  const [titleAlignment, setTitleAlignment] = useState("");
  const [titleSize, setTitleSize] = useState("");
  const swiperRef_c_1 = useRef(null);

  useEffect(() => {
    setBackgroundColor(component.web_background_color);
    setTitleColor(component.web_title_color);
    setTitleFont(component.web_title_font);
    setTitle(component.title);
    setTitleSize(component.title_size);
    setTitleAlignment(component.title_alignment);
    
  }, []);

  const categories = data["get_home_component_details"]["content"];
  const component = data;
  

  const loadGoogleFont = (fontName) => {
      if (!fontName) return;
  
      const f = fontName.trim();
      const lower = f.toLowerCase();
  
      if (lower === "sans" || lower === "serif" || lower === "mono") return;
  
      const formatted = f.replace(/\s+/g, "+");
      const id = `gf-${formatted.toLowerCase()}`;
  
      if (document.getElementById(id)) return;
  
      const link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href = `https://fonts.googleapis.com/css2?family=${formatted}&display=swap`;
      document.head.appendChild(link);
    };
  
    const getFontFamily = (font) => {
      if (!font) return "inherit";
  
      const f = font.toLowerCase().trim();
  
      if (f === "sans") return "ui-sans-serif, system-ui, -apple-system, sans-serif";
      if (f === "serif" || f === "sherif")
        return 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif';
      if (f === "mono")
        return 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace';
  
      return font;
    };
  
      useEffect(() => {
      
      loadGoogleFont(titleFont);
    
    }, [titleFont]);

  return (
    <div className="px-2 pb-3" style={{ background: backgroundColor }}>
      <div
        className={`text-2xl font-bold ${
          titleAlignment === "center"
            ? "text-center"
            : titleAlignment === "start"
            ? "text-left"
            : "text-center"
        }`}
        style={{
          color: titleColor,
          fontFamily: getFontFamily(titleFont),
          textSizeAdjust: titleSize,
        }}
      >
        {title}
      </div>

      {/* Desktop View: 6 Cards per Row, No Gap, Fully Rounded */}
      <div className="flex-wrap justify-center hidden space-x-0 overflow-hidden lg:flex">
        {categories.map((category) => (
          <div
            key={category.maincategory_auto_id}
            className="flex justify-center"
          >
            <div
              className="flex items-center p-2 text-center"
              style={{ maxWidth: "160px" }}
            >
              <Link
                to={`/maincategory/${category.maincategory_auto_id}`}
                className="flex flex-col items-center text-decoration-none"
              >
                {/* Fully Rounded Image */}
                <img
                  src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                  alt={category.main_category_name}
                  className="object-cover rounded-full"
                  style={{
                    height: "140px",
                    width: "140px",
                  }}
                />
              </Link>
            </div>
          </div>
        ))}
      </div>
      {/* Mobile View: Rounded Carousel with 4 Items */}
      <div
        className="relative lg:hidden"
        style={{ background: backgroundColor }}
      >
        <Swiper
          ref={swiperRef_c_1}
          slidesPerView={5}
          spaceBetween={10}
          navigation={{
            nextEl: `.swiper-button-next-${data._id}`,
            prevEl: `.swiper-button-prev-${data._id}`,
          }}
          modules={[Navigation]}
          className="mySwiper"
        >
          {categories.map((category) => (
            <SwiperSlide key={category.maincategory_auto_id}>
              <div className="flex justify-center">
                <div className="flex items-center p-1 text-center">
                  <Link
                    to={`/maincategory/${category.maincategory_auto_id}`}
                    className="flex flex-col items-center text-gray-800 no-underline hover:text-blue-600"
                  >
                    {/* Fully Rounded Image */}
                    <img
                      src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                      alt={category.main_category_name}
                      className="object-cover rounded-full"
                      style={{
                        height: "64px",
                        width: "64px",
                      }}
                    />
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Navigation Arrows */}
        <div className={`swiper-button-next-${data._id}`}></div>
        <div className={`swiper-button-prev-${data._id}`}></div>
      </div>
    </div>
  );
};

export default Category1;
